<template>
  <div>
    <Flash />

    <div class="l-wrapper">
      <div class="l-container">
        <!-- ヘッダー -->
        <PublicHeader />

        <!-- コンテンツ -->
        <main class="l-content">
          <router-view />
        </main>

        <!-- フッター -->
        <Footer use-service="kcom" />
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '../components/Footer'
import Flash from '../components/Flash'
import PublicHeader from '../components/PublicHeader'

export default {
  name: 'Public',
  components: {
    Footer,
    Flash,
    PublicHeader
  },
  data() {
    return {
    }
  },
  created() {
    if (gon.notice) this.$updateFlash({ type: 'notice', message: gon.notice })
    if (gon.alert) this.$updateFlash({ type: 'alert', message: gon.alert })
  },
  methods: {
  }
}
</script>
